export const Master = {
  categories: [
    {
      id: '1',
      name: 'Food & Beverage',
      slug: 'f-n-b',
    },
    {
      id: '2',
      name: 'Fashion',
      slug: 'fashion',
    },
    {
      id: '3',
      name: 'Lifestyle',
      slug: 'lifestyle',
    },
    {
      id: '4',
      name: 'Groceries',
      slug: 'groceries',
    },
    {
      id: '5',
      name: 'Health & Beauty',
      slug: 'health-beauty',
    },
  ],
  cities: [
    {
      id: '1',
      name: 'Bandung',
      slug: 'bandung',
    },
  ],
  promo: {
    id: [
      {
        id: '1',
        title: 'Unifist Brasseie & Bar - Diskon 10%',
        category: 'Food & Beverage ',
        periode: 'Hingga 31 Agustus 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/02/27/07/48/unifist-brasseie-bar',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/02/20230227-UNIFIST-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/02/20230227-UNIFIST-logo',
      },
      {
        id: '2',
        title: 'Jumbo Restaurant - Dapatkan Voucher Rp 300 Ribu',
        category: 'Food & Beverage ',
        periode: 'Hingga 31 Agustus 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/02/28/07/06/Jumbo-Restaurant',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/02/20230228-Jumbo-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/02/20230228-Jumbo-logo',
      },
      {
        id: '3',
        title: 'House of Brew - Diskon 10%',
        category: 'Food & Beverage ',
        periode: 'Hingga 31 Agustus 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/02/17/02/48/houseofbrew',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/02/20230217-houseofbrew-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/02/20230217-houseofbrew-logo',
      },
      {
        id: '4',
        title: 'Desooda Food Speaks - Diskon 30%',
        category: 'Food & Beverage ',
        periode: 'Hingga 31 Juli 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/02/01/03/11/desooda-foodspeaks',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/01/20230201-desooda-foodspeaks-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/01/20230201-desooda-foodspeaks-logo',
      },
      {
        id: '5',
        title: 'Moon Chicken - Diskon 50% di Moon Chicken',
        category: 'Food & Beverage ',
        periode: 'Hingga 28 Juli 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/01/31/03/10/Moon-Chicken',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/01/20230131-moon-chicken-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/01/20230131-moon-chicken-logo',
      },
      {
        id: '6',
        title: 'Radisson Hotel - Penawaran Spesial',
        category: 'Lifestyle',
        periode: 'Hingga 31 Juli 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/01/30/04/05/radisson-hotel',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/01/20230130-radisson-thu',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/01/20230130-radisson-logo',
      },
      {
        id: '7',
        title: 'Ah Yat Abalone - Diskon 20% Menu Makanan',
        category: 'Food & Beverage ',
        periode: 'Hingga 31 Desember 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/01/11/10/07/Ah-Yat-Abalone',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/01/20230111-abalone-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/01/20230111-abalone-logo',
      },
      {
        id: '8',
        title: 'Biomedilab - Ekstra Diskon 5% untuk Paket MCU',
        category: 'Lifestyle',
        periode: 'Hingga 31 Oktober 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2022/12/02/03/23/Biomedilab',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2022/12/20221202-Biomedi-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2022/12/20221202-Biomedi-logo',
      },
      {
        id: '9',
        title: 'Second Floor Coffee - Diskon 50%',
        category: 'Food & Beverage ',
        periode: 'Hingga 25 Desember 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2022/11/16/07/57/second-floor-coffee',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2022/11/20221116-second-floor-coffee-thu',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2022/11/20221116-second-floor-coffee-logo',
      },
      {
        id: '10',
        title: 'Eka Jaya Fast Boat - Diskon 20% Fast Boat',
        category: 'Lifestyle',
        periode: 'Hingga 31 Oktober 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2022/11/08/03/21/eka-jaya-fast-boat',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2022/11/20221108-eka-jaya-fast-boat-thu',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2022/11/20221108-eka-jaya-fast-boat-logo',
      },
      {
        id: '11',
        title: 'Flash Coffee - Diskon 20%',
        category: 'Food & Beverage ',
        periode: 'Hingga 10 Agustus 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2021/11/25/10/55/flash-coffee',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2021/11/20211125-flash-coffee-thumbnail',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/Icon/2023/03/20230301-flash-coffee-logo',
      },
      {
        id: '12',
        title: 'Burger King - Diskon Hingga 50%',
        category: 'Food & Beverage ',
        periode: 'Hingga 10 Januari 2024',
        link: 'https://www.bca.co.id/id/promo-bca/2023/04/17/07/14/Burger-King',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/04/20230417-BK-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/04/20230417-BK-logo',
      },
      {
        id: '13',
        title: 'Janji Jiwa - Beli 2 Dapat 3',
        category: 'Food & Beverage ',
        periode: 'Hingga 31 Januari 2024',
        link: 'https://www.bca.co.id/id/promo-bca/2023/03/30/03/09/Janji-Jiwa',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/03/20230330-JANJI-JIWA-thumbnail',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/Icon/2022/08/20220804-Janji-Jiwa-logo',
      },
      {
        id: '14',
        title: 'Kopi Dibawahtangga - Diskon hingga 50%',
        category: 'Food & Beverage ',
        periode: 'Hingga 31 Desember 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/04/04/02/28/kopi-dibawahtangga',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/04/20230404-DBT-thu',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/04/20230404-DBT-logo',
      },
      {
        id: '15',
        title: 'Kopi Dibawahtangga Aguna - Diskon hingga 20%',
        category: 'Food & Beverage ',
        periode: 'Hingga 31 Desember 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/03/30/04/01/kopi-dibawahtangga-aguna',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/03/20230330-kopi-dibawahtangga-aguna-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/03/20230330-kopi-dibawahtangga-aguna-logo',
      },
      {
        id: '16',
        title: 'Alba Ristorante - Dapatkan Tambahan 1 Slice Cake / Pastry',
        category: 'Food & Beverage ',
        periode: 'Hingga 13 Juli 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/04/12/03/13/Alba-Ristorante',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/04/20230412-Alba-Ristorante-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/04/20230412-Alba-Ristorante-logo',
      },
      {
        id: '17',
        title: 'Alba Pasticceria - Beli 3 Dapat 4 Scoop Gelato',
        category: 'Food & Beverage ',
        periode: 'Hingga 13 Juli 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/04/11/07/41/Alba-Pasticceria',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/04/20230411-Alba-Pasticceria-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/04/20230411-Alba-Pasticceria-logo',
      },
      {
        id: '18',
        title: 'Casa Alba - Dapatkan Dessert',
        category: 'Food & Beverage ',
        periode: 'Hingga 13 Juli 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/04/10/02/01/casa-alba',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/04/20230410-casa-alba-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/04/20230410-casa-alba-logo',
      },
      {
        id: '19',
        title: 'Breadlife - Dapatkan Ekstra Roti',
        category: 'Food & Beverage ',
        periode: 'Hingga 31 Desember 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/05/29/04/03/Breadlife',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/05/20230529-Breadlie-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/05/20230529-Breadlie-logo',
      },
      {
        id: '20',
        title: 'Dailybox - Potongan Hingga Rp20.000',
        category: 'Food & Beverage ',
        periode: 'Hingga 31 Desember 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/04/13/08/46/Dailybox',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/04/20230413-Dailybox-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/04/20230413-Dailybox-logo',
      },
      {
        id: '21',
        title: 'Inferno - Dapatkan Dessert',
        category: 'Food & Beverage ',
        periode: 'Hingga 13 Juli 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/04/12/09/27/Inferno',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/04/20230412-Inferno-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/04/20230412-Inferno-logo',
      },
      {
        id: '22',
        title: 'Pan & Co - Diskon Rp50 Ribu',
        category: 'Food & Beverage ',
        periode: 'Hingga 16 Agustus 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/05/19/09/52/pan-and-co',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/05/20230519-pan-and-co-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/05/20230519-pan-and-co-logo',
      },
      {
        id: '23',
        title: '7.AM Bakers - Dapatkan Menu Spesial',
        category: 'Food & Beverage ',
        periode: 'Hingga 12 Februari 2024',
        link: 'https://www.bca.co.id/id/promo-bca/2023/06/07/09/49/7am-bakers',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/06/20230607-7am-bakers-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/06/20230607-7am-bakers-logo',
      },
      {
        id: '24',
        title: 'A&W - Bonus hingga 2 Burger',
        category: 'Food & Beverage ',
        periode: 'Hingga 13 Februari 2024',
        link: 'https://www.bca.co.id/id/promo-bca/2023/06/22/05/59/a-and-w',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/06/20230622-a-and-w-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/06/20230622-a-and-w-logo',
      },
      {
        id: '25',
        title: 'Cinnabon - Bonus Upsize Minuman',
        category: 'Food & Beverage ',
        periode: 'Hingga 15 September 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/05/25/08/55/cinnabon',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/05/20230525-cinnabon-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/05/20230525-cinnabon-logo',
      },
      {
        id: '26',
        title: 'Cut&Grill - Potongan Rp100 Ribu',
        category: 'Food & Beverage ',
        periode: 'Hingga 6 Agustus 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/03/09/03/40/Cut-Grill',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/03/20230309-cut-grill-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/03/20230309-cut-grill-logo',
      },
      {
        id: '27',
        title: 'HopHop - Diskon hingga Rp20 Ribu',
        category: 'Food & Beverage ',
        periode: 'Hingga 31 Januari 2024',
        link: 'https://www.bca.co.id/id/promo-bca/2023/06/23/08/48/HopHop',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2023/06/20230623-HopHop-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/06/20230623-HopHop-logo',
      },
      {
        id: '28',
        title: 'Ikkudo Ichi - Dapatkan Menu Spesial',
        category: 'Food & Beverage ',
        periode: 'Hingga 13 Februari 2024',
        link: 'https://www.bca.co.id/id/promo-bca/2021/04/23/08/29/ikkudo-ichi',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/06/20230613-ikkudo-ichi-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/06/20230613-ikkudo-ichi-logo',
      },
      {
        id: '29',
        title: 'Kopi Kenangan - Beli 1 Dapat 2 & Diskon hingga 20%',
        category: 'Food & Beverage ',
        periode: 'Hingga 28 Februari 2024',
        link: 'https://www.bca.co.id/id/promo-bca/2023/06/20/04/11/Kopi-Kenangan?',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/06/Kopi-Kenangan-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/06/Kopi-Kenangan-logo',
      },
      {
        id: '30',
        title: 'Terra - Hemat Rp50ribu Min transkasi Rp500ribu',
        category: 'Food & Beverage ',
        periode: 'Hingga 6 Agustus 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/04/28/08/40/Terra',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/04/20230428-Terra-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/04/20230428-Terra-logo',
      },
      {
        id: '31',
        title: 'Tokyo Hub - Dapatkan Voucher Rp50.000',
        category: 'Food & Beverage ',
        periode: 'Hingga 4 Agustus 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/03/31/04/03/Tokyo-Hub',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/03/20230331-Tokyo-Hub-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/03/20230331-Tokyo-Hub-logo',
      },
      {
        id: '32',
        title: 'Toma - Potongan Rp 100 Rb',
        category: 'Food & Beverage ',
        periode: 'Hingga 7 Agustus 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/03/07/02/10/Toma',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/03/20230307-TB-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/03/20230307-TB-logo',
      },
      {
        id: '33',
        title: 'Baso Afung - Harga Spesial Mulai Rp1',
        category: 'Food & Beverage ',
        periode: 'Hingga 29 Januari 2024',
        link: 'https://www.bca.co.id/id/promo-bca/2023/06/09/10/48/Baso-Afung',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/06/Afung-web-thumbnail',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/06/Afung-web-logo',
      },
      {
        id: '34',
        title: 'Es Teler 77 - Diskon hingga 50% dan Harga Spesial Rp1',
        category: 'Food & Beverage ',
        periode: 'Hingga 9 Februari 2024',
        link: 'https://www.bca.co.id/id/promo-bca/2023/06/09/03/14/es-teler-77',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/06/20230609-es-teler-77-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/06/20230609-es-teler-77-logo',
      },
      {
        id: '35',
        title: 'Milou Farm House - Diskon 50%',
        category: 'Food & Beverage ',
        periode: 'Hingga 27 September 2023',
        link: 'https://www.bca.co.id/id/promo-bca/2023/07/03/09/11/Milou-Farm-House',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/07/20230703-MFH-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/07/20230703-MFH-logo',
      },
      {
        id: '36',
        title: 'CINEPOLIS - Penawaran Spesial',
        category: 'Food & Beverage ',
        periode: 'Hingga 31 Oktober 2024',
        link: 'https://www.bca.co.id/id/promo-bca/2022/09/06/03/02/cinepolis',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2023/07/20230713-Cinepolis-Thumb-rev',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/Icon/2023/07/20230713-Cinepolis-Logo-rev',
      },
      {
        id: '37',
        title: 'Hop Hop Signature - Diskon Rp20 Ribu',
        category: 'Food & Beverage ',
        periode: 'Hingga 15 Februari 2024',
        link: 'https://www.bca.co.id/id/promo-bca/2023/08/25/08/59/hop-hop-signature',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/08/20230825-hop-hop-signature-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/08/20230825-hop-hop-signature-logo',
      },
      {
        id: '38',
        title: 'Oriskin - Diskon hingga 50%',
        category: 'Lifestyle',
        periode: 'Hingga 29 Februari 2024',
        link: 'https://www.bca.co.id/id/promo-bca/2023/08/23/03/50/Oriskin',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/08/20230823-ORISIKIN-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/08/20230823-ORISIKIN-logo',
      },
      {
        id: '39',
        title: 'ADIDAS - Potongan Rp100 Ribu',
        category: 'Lifestyle',
        periode: 'Hingga 26 Agustus 2024',
        link: 'https://www.bca.co.id/id/promo-bca/2023/04/05/02/28/ADIDAS',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/06/20230615-ADIDAS-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/06/20230615-ADIDAS-logo',
      },
      {
        id: '40',
        title: 'SUN & SANDS - Potongan Rp100 Ribu',
        category: 'Lifestyle',
        periode: 'Hingga 26 Agustus 2024',
        link: 'https://www.bca.co.id/id/promo-bca/2023/07/06/04/10/sun-and-sands',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/07/20230607-sun-and-sands-thu',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/07/20230607-sun-and-sands-logo',
      },
      {
        id: '41',
        title: 'Vans - Potongan Rp100 Ribu',
        category: 'Lifestyle',
        periode: 'Hingga 26 Agustus 2024',
        link: 'https://www.bca.co.id/id/promo-bca/2023/04/05/08/49/Vans',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/05/20230519-VANS-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/05/20230519-VANS-logo',
      },
    ],
    en: [
      {
        id: '1',
        title: 'Unifist Brasseie & Bar - Discount 10%',
        category: 'Food & Beverage ',
        periode: 'Until 31 August 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/02/27/07/48/unifist-brasseie-bar',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/02/20230227-UNIFIST-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/02/20230227-UNIFIST-logo',
      },
      {
        id: '2',
        title: 'Jumbo Restaurant - Get Voucher IDR 300.000',
        category: 'Food & Beverage ',
        periode: 'Until 31 August 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/02/28/07/06/Jumbo-Restaurant',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/02/20230228-Jumbo-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/02/20230228-Jumbo-logo',
      },
      {
        id: '3',
        title: 'House of Brew - Discount 10%',
        category: 'Food & Beverage ',
        periode: 'Until 31 August 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/02/17/02/48/houseofbrew',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/02/20230217-houseofbrew-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/02/20230217-houseofbrew-logo',
      },
      {
        id: '4',
        title: 'Desooda Food Speaks - Discount 30%',
        category: 'Food & Beverage ',
        periode: 'Until 31 July 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/02/01/03/11/desooda-foodspeaks',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/01/20230201-desooda-foodspeaks-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/01/20230201-desooda-foodspeaks-logo',
      },
      {
        id: '5',
        title: 'Moon Chicken - Discount 50%',
        category: 'Food & Beverage ',
        periode: 'Until 28 July 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/01/31/03/10/Moon-Chicken',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/01/20230131-moon-chicken-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/01/20230131-moon-chicken-logo',
      },
      {
        id: '6',
        title: 'Radisson Hotel - Special Offer',
        category: 'Lifestyle',
        periode: 'Until 31 July 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/01/30/04/05/radisson-hotel',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/01/20230130-radisson-thu',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/01/20230130-radisson-logo',
      },
      {
        id: '7',
        title: 'Ah Yat Abalone - Discount 20% Food Menu',
        category: 'Food & Beverage ',
        periode: 'Until 31 December 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/01/11/10/07/Ah-Yat-Abalone',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/01/20230111-abalone-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/01/20230111-abalone-logo',
      },
      {
        id: '8',
        title: 'Biomedilab - Extra Discount 5% for MCU Package',
        category: 'Lifestyle',
        periode: 'Until 31 October 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2022/12/02/03/23/Biomedilab',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2022/12/20221202-Biomedi-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2022/12/20221202-Biomedi-logo',
      },
      {
        id: '9',
        title: 'Second Floor Coffee - Discount 50%',
        category: 'Food & Beverage ',
        periode: 'Until 25 December 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2022/11/16/07/57/second-floor-coffee',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2022/11/20221116-second-floor-coffee-thu',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2022/11/20221116-second-floor-coffee-logo',
      },
      {
        id: '10',
        title: 'Eka Jaya Fast Boat - Discount 20% Fast Boat',
        category: 'Lifestyle',
        periode: 'Until 31 October 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2022/11/08/03/21/eka-jaya-fast-boat',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2022/11/20221108-eka-jaya-fast-boat-thu',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2022/11/20221108-eka-jaya-fast-boat-logo',
      },
      {
        id: '11',
        title: 'Flash Coffee - Discount 20%',
        category: 'Food & Beverage ',
        periode: 'Until 10 August 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2021/11/25/10/55/flash-coffee',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2021/11/20211125-flash-coffee-thumbnail',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/Icon/2023/03/20230301-flash-coffee-logo',
      },
      {
        id: '12',
        title: 'Burger King - Discount up to 50%',
        category: 'Food & Beverage ',
        periode: 'Until 10 January 2024',
        link: 'https://www.bca.co.id/en/promo-bca/2023/04/17/07/14/Burger-King',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/04/20230417-BK-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/04/20230417-BK-logo',
      },
      {
        id: '13',
        title: 'Janji Jiwa - Buy 2 Get 3',
        category: 'Food & Beverage ',
        periode: 'Until 31 January 2024',
        link: 'https://www.bca.co.id/en/promo-bca/2023/03/30/03/09/Janji-Jiwa',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/03/20230330-JANJI-JIWA-thumbnail',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/Icon/2022/08/20220804-Janji-Jiwa-logo',
      },
      {
        id: '14',
        title: 'Kopi Dibawahtangga - Discount up to 50%',
        category: 'Food & Beverage ',
        periode: 'Until 31 December 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/04/04/02/28/kopi-dibawahtangga',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/04/20230404-DBT-thu',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/04/20230404-DBT-logo',
      },
      {
        id: '15',
        title: 'Kopi Dibawahtangga Aguna - Discount up to 20%',
        category: 'Food & Beverage ',
        periode: 'Until 31 December 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/03/30/04/01/kopi-dibawahtangga-aguna',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/03/20230330-kopi-dibawahtangga-aguna-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/03/20230330-kopi-dibawahtangga-aguna-logo',
      },
      {
        id: '16',
        title: 'Alba Ristorante - Get 1 Additional Slice Cake / Pastry',
        category: 'Food & Beverage ',
        periode: 'Until 13 July 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/04/12/03/13/Alba-Ristorante',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/04/20230412-Alba-Ristorante-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/04/20230412-Alba-Ristorante-logo',
      },
      {
        id: '17',
        title: 'Alba Pasticceria - Buy 3 Get 4 Scoop Gelato',
        category: 'Food & Beverage ',
        periode: 'Until 13 July 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/04/11/07/41/Alba-Pasticceria',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/04/20230411-Alba-Pasticceria-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/04/20230411-Alba-Pasticceria-logo',
      },
      {
        id: '18',
        title: 'Casa Alba - Get a Dessert',
        category: 'Food & Beverage ',
        periode: 'Until 13 July 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/04/10/02/01/casa-alba',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/04/20230410-casa-alba-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/04/20230410-casa-alba-logo',
      },
      {
        id: '19',
        title: 'Breadlife - Get Extra Bread',
        category: 'Food & Beverage ',
        periode: 'Until 31 December 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/05/29/04/03/Breadlife',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/05/20230529-Breadlie-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/05/20230529-Breadlie-logo',
      },
      {
        id: '20',
        title: 'Dailybox - Discount up to IDR 20.000',
        category: 'Food & Beverage ',
        periode: 'Until 31 December 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/04/13/08/46/Dailybox',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/04/20230413-Dailybox-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/04/20230413-Dailybox-logo',
      },
      {
        id: '21',
        title: 'Inferno - Get a Dessert',
        category: 'Food & Beverage ',
        periode: 'Until 13 July 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/04/12/09/27/Inferno',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/04/20230412-Inferno-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/04/20230412-Inferno-logo',
      },
      {
        id: '22',
        title: 'Pan & Co - Discount IDR 50.000',
        category: 'Food & Beverage ',
        periode: 'Until 16 August 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/05/19/09/52/pan-and-co',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/05/20230519-pan-and-co-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/05/20230519-pan-and-co-logo',
      },
      {
        id: '23',
        title: '7.AM Bakers - Get Special Menu',
        category: 'Food & Beverage ',
        periode: 'Until 12 February 2024',
        link: 'https://www.bca.co.id/en/promo-bca/2023/06/07/09/49/7am-bakers',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/06/20230607-7am-bakers-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/06/20230607-7am-bakers-logo',
      },
      {
        id: '24',
        title: 'A&W - Bonus up to 2 Burger',
        category: 'Food & Beverage ',
        periode: 'Until 13 February 2024',
        link: 'https://www.bca.co.id/en/promo-bca/2023/06/22/05/59/a-and-w',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/06/20230622-a-and-w-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/06/20230622-a-and-w-logo',
      },
      {
        id: '25',
        title: 'Cinnabon - Bonus Upsize Beverage',
        category: 'Food & Beverage ',
        periode: 'Until 15 September 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/05/25/08/55/cinnabon',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/05/20230525-cinnabon-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/05/20230525-cinnabon-logo',
      },
      {
        id: '26',
        title: 'Cut&Grill - Discount IDR 100.000',
        category: 'Food & Beverage ',
        periode: 'Until 6 August 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/03/09/03/40/Cut-Grill',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/03/20230309-cut-grill-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/03/20230309-cut-grill-logo',
      },
      {
        id: '27',
        title: 'HopHop - Discount up to IDR 20.000',
        category: 'Food & Beverage ',
        periode: 'Until 31 January 2024',
        link: 'https://www.bca.co.id/en/promo-bca/2023/06/23/08/48/HopHop',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2023/06/20230623-HopHop-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/06/20230623-HopHop-logo',
      },
      {
        id: '28',
        title: 'Ikkudo Ichi - Get Special Menu',
        category: 'Food & Beverage ',
        periode: 'Until 13 February 2024',
        link: 'https://www.bca.co.id/en/promo-bca/2021/04/23/08/29/ikkudo-ichi',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/06/20230613-ikkudo-ichi-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/06/20230613-ikkudo-ichi-logo',
      },
      {
        id: '29',
        title: 'Kopi Kenangan - Buy 1 Get 2 & Discount up to 20%',
        category: 'Food & Beverage ',
        periode: 'Until 28 February 2024',
        link: 'https://www.bca.co.id/en/promo-bca/2023/06/20/04/11/Kopi-Kenangan?',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/06/Kopi-Kenangan-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/06/Kopi-Kenangan-logo',
      },
      {
        id: '30',
        title: 'Terra - Save IDR 50.000 with minimum transaction IDR 500.000',
        category: 'Food & Beverage ',
        periode: 'Until 6 August 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/04/28/08/40/Terra',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/04/20230428-Terra-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/04/20230428-Terra-logo',
      },
      {
        id: '31',
        title: 'Tokyo Hub - Get Voucher IDR 50.000',
        category: 'Food & Beverage ',
        periode: 'Until 4 August 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/03/31/04/03/Tokyo-Hub',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/03/20230331-Tokyo-Hub-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/03/20230331-Tokyo-Hub-logo',
      },
      {
        id: '32',
        title: 'Toma - Discount IDR 100.000',
        category: 'Food & Beverage ',
        periode: 'Until 7 August 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/03/07/02/10/Toma',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/03/20230307-TB-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/03/20230307-TB-logo',
      },
      {
        id: '33',
        title: 'Baso Afung - Special price start from IDR 1 ',
        category: 'Food & Beverage ',
        periode: 'Until 29 January 2024',
        link: 'https://www.bca.co.id/en/promo-bca/2023/06/09/10/48/Baso-Afung',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/06/Afung-web-thumbnail',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/06/Afung-web-logo',
      },
      {
        id: '34',
        title: 'Es Teler 77 - Discount up to 50% & Special Price IDR 1',
        category: 'Food & Beverage ',
        periode: 'Until 9 February 2024',
        link: 'https://www.bca.co.id/en/promo-bca/2023/06/09/03/14/es-teler-77',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/06/20230609-es-teler-77-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/06/20230609-es-teler-77-logo',
      },
      {
        id: '35',
        title: 'Milou Farm House - Discount 50%',
        category: 'Food & Beverage ',
        periode: 'Until 27 September 2023',
        link: 'https://www.bca.co.id/en/promo-bca/2023/07/03/09/11/Milou-Farm-House',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/07/20230703-MFH-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/07/20230703-MFH-logo',
      },
      {
        id: '36',
        title: 'CINEPOLIS - Special Offer',
        category: 'Food & Beverage ',
        periode: 'Until 31 October 2024',
        link: 'https://www.bca.co.id/en/promo-bca/2022/09/06/03/02/cinepolis',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2023/07/20230713-Cinepolis-Thumb-rev',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/Icon/2023/07/20230713-Cinepolis-Logo-rev',
      },
      {
        id: '37',
        title: 'Hop Hop Signature - Discount IDR 20.000',
        category: 'Food & Beverage ',
        periode: 'Until 15 February 2024',
        link: 'https://www.bca.co.id/en/promo-bca/2023/08/25/08/59/hop-hop-signature',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/08/20230825-hop-hop-signature-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/08/20230825-hop-hop-signature-logo',
      },
      {
        id: '38',
        title: 'Oriskin - Discount up to 50%',
        category: 'Lifestyle',
        periode: 'Until 29 February 2024',
        link: 'https://www.bca.co.id/en/promo-bca/2023/08/23/03/50/Oriskin',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/08/20230823-ORISIKIN-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/08/20230823-ORISIKIN-logo',
      },
      {
        id: '39',
        title: 'ADIDAS - Discount IDR 100.000',
        category: 'Lifestyle',
        periode: 'Until 26 August 2024',
        link: 'https://www.bca.co.id/en/promo-bca/2023/04/05/02/28/ADIDAS',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/06/20230615-ADIDAS-thum',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/06/20230615-ADIDAS-logo',
      },
      {
        id: '40',
        title: 'SUN & SANDS - Discount IDR 100.000',
        category: 'Lifestyle',
        periode: 'Until 26 August 2024',
        link: 'https://www.bca.co.id/en/promo-bca/2023/07/06/04/10/sun-and-sands',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/07/20230607-sun-and-sands-thu',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/07/20230607-sun-and-sands-logo',
      },
      {
        id: '41',
        title: 'Vans - SUN & SANDS - Discount IDR 100.000',
        category: 'Lifestyle',
        periode: 'Until 26 August 2024',
        link: 'https://www.bca.co.id/en/promo-bca/2023/04/05/08/49/Vans',
        thumbnail: 'https://www.bca.co.id/-/media/Feature/Promo/thumbnail/2023/05/20230519-VANS-thumb',
        logo: 'https://www.bca.co.id/-/media/Feature/Promo/icon/2023/05/20230519-VANS-logo',
      },
    ],
  },
};
